import {
  useQuantityStepper
} from "./chunk-47D32CZV.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-32ZPS4GN.mjs";

// src/quantity-stepper/QuantityStepper.tsx
import React, {
  cloneElement,
  isValidElement
} from "react";
var QuantityStepper = (_a) => {
  var _b = _a, {
    visible = true,
    leftStepButton,
    rightStepButton,
    children,
    containerProps = {}
  } = _b, rest = __objRest(_b, [
    "visible",
    "leftStepButton",
    "rightStepButton",
    "children",
    "containerProps"
  ]);
  const { decrementButtonProps, incrementButtonProps } = useQuantityStepper(__spreadProps(__spreadValues({}, rest), {
    visible
  }));
  return /* @__PURE__ */ React.createElement("div", __spreadValues({}, containerProps), isValidElement(leftStepButton) && cloneElement(leftStepButton, __spreadProps(__spreadValues({}, decrementButtonProps), {
    visible
  })), children, isValidElement(rightStepButton) && cloneElement(rightStepButton, __spreadProps(__spreadValues({}, incrementButtonProps), {
    visible
  })));
};

export {
  QuantityStepper
};
